import { cx } from "components/Graphs/utils";
import { ChevronLeft, ChevronRight } from "lucide-react";
import React from "react";

export interface ShellRailToggleProps {
  expanded: boolean;
  onToggle: () => void;
  controlsId?: string;
  className?: string;
}

export const ShellRailToggle: React.FC<ShellRailToggleProps> = ({
  expanded,
  onToggle,
  controlsId,
  className,
}) => {
  const Icon = expanded ? ChevronLeft : ChevronRight;
  const label = expanded ? "Collapse navigation" : "Expand navigation";

  return (
    <button
      type="button"
      className={cx(
        "group absolute -right-3 top-0 z-20 h-full w-6 cursor-col-resize border-0 bg-transparent p-0 outline-none",
        "after:absolute after:bottom-0 after:left-1/2 after:top-0 after:w-px after:-translate-x-1/2 after:bg-highlight/60 after:opacity-0 after:transition-opacity",
        "hover:after:opacity-100 focus-visible:after:opacity-100",
        "motion-reduce:after:transition-none",
        className,
      )}
      aria-label={label}
      aria-expanded={expanded}
      aria-controls={controlsId}
      onClick={onToggle}
      data-shell-rail-toggle=""
    >
      <span
        className={cx(
          "absolute left-1/2 top-1/2 flex size-6 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-zinc-600 bg-[#111412] text-zinc-300 opacity-0 shadow-[0_4px_16px_rgba(0,0,0,0.48)] transition-[opacity,border-color,color,background-color]",
          "group-hover:border-zinc-500 group-hover:bg-[#171a18] group-hover:text-white group-hover:opacity-100",
          "group-focus-visible:border-highlight/70 group-focus-visible:text-white group-focus-visible:opacity-100 group-focus-visible:ring-2 group-focus-visible:ring-highlight/35",
          "motion-reduce:transition-none",
        )}
        aria-hidden="true"
      >
        <Icon className="size-3.5" strokeWidth={1.8} />
      </span>
    </button>
  );
};

ShellRailToggle.displayName = "ShellRailToggle";

export default ShellRailToggle;
